//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Menu from "../Az/Footer/Menu";
//Install
import Social from "../Az/Footer/Social";
//Install
import Copyright from "../Az/Footer/Copyright";
//Install
import Corporation from "../Az/Footer/Corporation";

//Element
class Footer extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("footer", { className: "S6pt64 C96Q4r pEO064 a527eB u3v98z" },
            //Element
            React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB p943pc" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Korporativ Məlumatlandırma"
                                ),
                                //Element
                                React.createElement(Corporation, {})
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Təqdim Edilən Xidmətlər"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/isiqlandirma" },
                                            //Element
                                            "İşıqlandırma"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/panel-istehsali" },
                                            //Element
                                            "Panel İstehsalı"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/elektrik-muqavilesi" },
                                            //Element
                                            "Elektrik Müqaviləsi"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/yenilene-bilen-enerji" },
                                            //Element
                                            "Yenilənə Bilən Enerji"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/orta-gerginlik-tesisleri" },
                                            //Element
                                            "Orta Gərginlik Təsisləri"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Kimlərə Xidmət Göstərildi?"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/layiheler" },
                                            //Element
                                            "Borusan"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/layiheler" },
                                            //Element
                                            "Kanyon"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/layiheler" },
                                            //Element
                                            "Arçelik"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/layiheler" },
                                            //Element
                                            "Vestel"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/layiheler" },
                                            //Element
                                            "Eczacıbaşı"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Əlaqə Məlumatları"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/elaqe" },
                                            //Element
                                            "Əlaqə"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Sosial mediada izləyin"
                                ),
                                //Element
                                React.createElement(Social, {})
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB g3i234" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 8 },
                            //Element
                            React.createElement(Copyright, { ID: "0", Title: "Müəllif Hüquqları © 2025 Temas Elektrik Müqaviləsi Məhdud Məsuliyyətli Şirkəti" })
                        ),
                        //Element
                        React.createElement(Col, { md: 4 },
                            //Element
                            React.createElement(Menu, {})
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Footer;